import { ChevronDownIcon } from "lucide-react";
import type * as React from "react";
import { cn } from "../cn";
import { FIELD_FOCUS } from "./focus-ring";

type NativeSelectProps = Omit<React.ComponentProps<"select">, "size"> & {
  size?: "sm" | "default" | "lg";
};

function NativeSelect({ className, size = "default", ...props }: NativeSelectProps) {
  return (
    <div
      className={cn(
        "group/native-select relative w-fit has-[select:disabled]:opacity-55",
        className,
      )}
      data-slot="native-select-wrapper"
      data-size={size}
    >
      <select
        data-slot="native-select"
        data-size={size}
        className={`h-9 w-full min-w-0 appearance-none rounded-md border border-input bg-card py-1 pr-8 pl-3 text-sm text-foreground shadow-sm transition-[color,border-color,box-shadow] duration-(--dur-fast) select-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground hover:border-strong ${FIELD_FOCUS} disabled:pointer-events-none disabled:cursor-not-allowed aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive data-[size=lg]:h-10 data-[size=sm]:h-7 data-[size=sm]:py-0.5 data-[size=sm]:pl-2.5 max-md:text-md`}
        {...props}
      />
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-faint select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  );
}

function NativeSelectOption({ className, ...props }: React.ComponentProps<"option">) {
  return (
    <option
      data-slot="native-select-option"
      className={cn("bg-[Canvas] text-[CanvasText]", className)}
      {...props}
    />
  );
}

function NativeSelectOptGroup({ className, ...props }: React.ComponentProps<"optgroup">) {
  return (
    <optgroup
      data-slot="native-select-optgroup"
      className={cn("bg-[Canvas] text-[CanvasText]", className)}
      {...props}
    />
  );
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption };
